export default {
  list: [
    {
      title: 'باز',
      value: 'OPEN'
    },
    {
      title: 'تعطیل',
      value: 'CLOSE'
    },
    {
      title: 'معلق',
      value: 'SUSPENDED'
    }
  ],
  values: {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    SUSPENDED: 'SUSPENDED'
  }
};
